import { useEffect } from 'react';

export default function EsyohWidget874239() {
  useEffect(() => {
    const scriptId = 'esyoh-widget-js';
    const init = () => {
      if (window.ESY && typeof window.ESY.Widget === 'function') {
        window.ESY.Widget({
          domain_id: 'hvacschoolslasvegas.com',
          widget_id: '874239',
        });
      } else {
        setTimeout(init, 100);
      }
    };

    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.src = 'https://www.esyoh.com/clients/js/widget.js?ver=3.0.0';
      script.async = true;
      script.onload = init;
      document.body.appendChild(script);
    } else {
      init();
    }
  }, []);

  return <div className="esy_widget_container" />;
}